import React from 'react';

function Bone({ className = '' }) {
  return <div className={`animate-pulse rounded bg-gray-200 ${className}`} />;
}

/**
 * Skeleton de grid de cards (listagens / favoritos / blog).
 * Usado na navegação interna quando o PreLoader já foi exibido na sessão.
 */
export default function PropertyGridSkeleton({ count = 8, className = '' }) {
  return (
    <div
      className={`grid grid-cols-1 min-[560px]:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 ${className}`}
      aria-busy="true"
      aria-label="Carregando"
    >
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="overflow-hidden rounded-lg bg-white shadow-sm">
          <Bone className="h-48 w-full rounded-none" />
          <div className="space-y-3 p-4">
            <Bone className="h-4 w-1/3" />
            <Bone className="h-5 w-3/4" />
            <Bone className="h-4 w-1/2" />
            <div className="grid grid-cols-2 gap-2 pt-2">
              <Bone className="h-4 w-full" />
              <Bone className="h-4 w-full" />
              <Bone className="h-4 w-full" />
              <Bone className="h-4 w-full" />
            </div>
            <Bone className="mt-2 h-10 w-full rounded-lg" />
          </div>
        </div>
      ))}
    </div>
  );
}

/** Skeleton de página de listagem completa (breadcrumb + título + grid). */
export function ListingPageSkeleton() {
  return (
    <div
      className="min-h-screen bg-gray-50"
      style={{ fontFamily: 'Montserrat, sans-serif' }}
      aria-busy="true"
      aria-label="Carregando"
    >
      <div className="mx-auto w-full max-w-[85rem] p-6">
        <div className="mb-8 flex flex-wrap items-center gap-2">
          <Bone className="h-4 w-14" />
          <Bone className="h-4 w-3" />
          <Bone className="h-4 w-28" />
        </div>
        <Bone className="mx-auto mb-8 h-9 w-72 max-w-full" />
        <Bone className="mb-6 h-[46px] w-full rounded-lg" />
        <PropertyGridSkeleton />
      </div>
    </div>
  );
}
